import api from '../../api';
import { push } from 'connected-react-router';
import { store as storeNotification } from 'react-notifications-component';
import { socket } from './../store/socket';

const notificationConfig = {
  container: 'top-center',
  animationIn: ['animated', 'fadeIn'],
  animationOut: ['animated', 'fadeOut'],
  dismiss: {
    duration: 1500,
    showIcon: true
  }
};

export const occurrencesStartRequest = () => {
  return {
    type: 'OCCURRENCES_START_REQUEST'
  };
};

export const occurrencesEndRequest = () => {
  return {
    type: 'OCCURRENCES_END_REQUEST'
  };
};

export const getAllOccurrencesSuccess = ({ data }) => {
  return {
    type: 'OCCURRENCES_GET_ALL_SUCCESS',
    payload: data
  };
};

export const getAllOccurrencesError = error => {
  return {
    type: 'OCCURRENCES_GET_ALL_ERROR',
    payload: error
  };
};

export const addOccurrencesSuccess = ({ data }) => {
  return {
    type: 'OCCURRENCES_ADD_SUCCESS',
    payload: data
  };
};

export const addOccurrencesError = error => {
  return {
    type: 'OCCURRENCES_ADD_ERROR',
    payload: error
  };
};

export const editOccurrencesSuccess = ({ data }) => {
  return {
    type: 'OCCURRENCES_EDIT_SUCCESS',
    payload: data
  };
};

export const editOccurrencesError = error => {
  return {
    type: 'OCCURRENCES_EDIT_ERROR',
    payload: error
  };
};

export const removeOccurrencesSuccess = id => {
  return {
    type: 'OCCURRENCES_REMOVE_SUCCESS',
    payload: id
  };
};

export const removeOccurrencesError = error => {
  return {
    type: 'OCCURRENCES_REMOVE_ERROR',
    payload: error
  };
};

export const occurrencesModifyStore = ({ data }) => {
  return {
    type: 'OCCURRENCES_MODIFY_STORE',
    payload: data
  };
};

export const addOccurrences = (data, formReset, submitBtn) => {
  return async dispatch => {
    try {
      submitBtn.disabled = true;
      dispatch(occurrencesStartRequest());
      const response = await api().post('/api/occurrences', data);
      dispatch(addOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'ADD',
        module: 'occurrences',
        data: [response.data],
        company: response.data.company
      });
      formReset();
    } catch (err) {
      dispatch(addOccurrencesError(err));
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      setTimeout(() => {
        dispatch(occurrencesEndRequest());
        submitBtn.disabled = false;
      }, 1800);
    }
  };
};

export const getAllOccurrences = (params = {}) => {
  return async dispatch => {
    try {
      dispatch(occurrencesStartRequest());
      const response = await api().get('/api/occurrences', { params });
      dispatch(getAllOccurrencesSuccess(response));
    } catch (err) {
      dispatch(getAllOccurrencesError(err));
    } finally {
      dispatch(occurrencesEndRequest());
    }
  };
};

export const editOccurrences = (data, submitBtn = {}, handleModalClose) => {
  return async dispatch => {
    const defaultMsg = button => {
      return new Promise(resolve => {
        document
          .getElementsByClassName('page-content')[0]
          .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
        setTimeout(() => {
          dispatch(occurrencesEndRequest());
          button.disabled = false;
          resolve(true);
        }, 1800);
      });
    };

    try {
      submitBtn.disabled = true;
      dispatch(occurrencesStartRequest());
      const id = data._id;
      const response = await api().put('/api/occurrences/' + id, data);
      dispatch(editOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'EDIT',
        module: 'occurrences',
        data: [response.data],
        company: response.data.company
      });
      await defaultMsg(submitBtn);
      if (handleModalClose) {
        handleModalClose();
      } else {
        dispatch(push('/occurrences'));
      }
    } catch (err) {
      dispatch(editOccurrencesError(err));
      await defaultMsg(submitBtn);
    }
  };
};

export const removeOccurrences = id => {
  return async dispatch => {
    try {
      dispatch(occurrencesStartRequest());
      await api().delete('/api/occurrences/' + id);
      dispatch(removeOccurrencesSuccess(id));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'REMOVE',
        module: 'occurrences',
        data: id
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Ocorrência removida com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(removeOccurrencesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao remover ocorrência.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(occurrencesEndRequest());
    }
  };
};

export const restoreOccurrences = data => {
  return async dispatch => {
    try {
      dispatch(occurrencesStartRequest());
      const id = data._id;
      const response = await api().put('/api/occurrences/' + id, data);
      dispatch(editOccurrencesSuccess(response));
      socket.emit('requestChangeStore', {
        token: localStorage.getItem('token') || '',
        type: 'RESTORE',
        module: 'occurrences',
        data: [response.data],
        company: response.data.company
      });
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Ocorrência restaurada com sucesso.',
          type: 'success'
        });
      }, 300);
    } catch (err) {
      dispatch(editOccurrencesError(err));
      setTimeout(() => {
        storeNotification.addNotification({
          ...notificationConfig,
          message: 'Falha ao restaurar ocorrência.',
          type: 'danger'
        });
      }, 300);
    } finally {
      document
        .getElementsByClassName('page-content')[0]
        .scrollTo({ top: 0, left: 0, behavior: 'smooth' });
      dispatch(occurrencesEndRequest());
    }
  };
};
